<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6 col-sm-8">
          <h5>Exam Types</h5>
        </div>
        <div class="col-6 col-sm-4 text-right">
          <add-exam-types v-if="pagepermission.insertable" @created="handleCreated"/>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <exam-types-table :data="data" :loading="loading" @updateTable="handleUpdateTable" />
          </div>
        </div>
        <div class="text-right">
          <a-pagination
              showSizeChanger
              @showSizeChange="onShowSizeChange"
              :total="meta.total"
              :pageSize.sync="pageSize"
              v-model="current"
              @change="onChange"
            >
          </a-pagination>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <p class="error">
        You don't have permission to use this feature.
      </p>
    </div>
  </div>
</template>

<script>
import ExamTypesTable from '@/components/bosemexam/types/Table/index'
import AddExamTypes from '@/components/bosemexam/types/Forms/Add/index'

export default {
  components: {
    ExamTypesTable,
    AddExamTypes,
  },
  beforeMount: function() {
    let rc = this.$roleutility.checkpermission('attendance', 22)
    rc.then(data => {
      console.log(data)
      this.pagepermission = data.pagePermission
    })
  },
  mounted: function() {
    this.getBoards()
  },
  data: function() {
    return {
      loading: false,
      visible: false,
      data: [],
      meta: {},
      current: 1,
      pageSize: 30,
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
    }
  },
  methods: {
    getBoards: function() {
      this.loading = true
      this.$http.get('/api/examtype', {
        params: {
          limit: this.pageSize,
          page: this.current,
        },
      }).then(({ data }) => {
        this.loading = false
        this.data = data.data
        this.meta = data.meta
      })
    },
    handleCreated: function() {
      this.getBoards()
    },
    handleUpdateTable: function() {
      this.getBoards()
    },
    onShowSizeChange(current, pageSize) {
      this.pageSize = pageSize
      this.current = current
      this.getBoards()
    },
    onChange(current) {
      this.current = current
      this.getBoards()
    },
  },
}
</script>
